module.exports = {
      id: "6677af68312a175a4e409dda3a02e8e7door.svg-usage",
      viewBox: "0 0 102 210",
      url: __webpack_public_path__ + "sprite.svg#6677af68312a175a4e409dda3a02e8e7door.svg",
      toString: function () {
        return this.url;
      }
    }